import React from 'react';

import PageTable, {
  PageTableCell,
  PageTableHeader,
  PageTableRow,
} from '../../../../components/Table/PageTable';
import { EnumPagingMode } from '../../../../constants/enum';
import { formatCurrency, formatDateTimeView } from '../../../../utils/utils';
import { trans } from '../../../../localization/index';
import TableEmpty from '../../../../components/Common/TableEmpty'

class NowPortalOrderTable extends React.Component {
  static renderHeader() {
    const columns = [
      {
        id: 'number',
        label: trans('merchant_order_header_stt'),
        textAlign: 'center',
      },
      {
        id: 'transaction_type',
        label: trans('np_transaction_type'),
        textAlign: 'left',
      },
      {
        id: 'amount',
        label: trans('general_amount'),
        textAlign: 'left',
      },
      {
        id: 'status',
        label: trans('general_status'),
        textAlign: 'left',
      },
      {
        id: 'store_name',
        label: trans('store_name'),
        textAlign: 'left',
      },
      {
        id: 'transaction_ref',
        label: trans('np_transaction_ref'),
        textAlign: 'left',
      },
      {
        id: 'order_code',
        label: trans('general_order_code'),
        textAlign: 'left',
      },
      {
        id: 'create_time',
        label: trans('np_created_time'),
        textAlign: 'left',
      },
      {
        id: 'payment_time',
        label: trans('np_payment_time'),
        textAlign: 'left',
      },
      {
        id: 'description',
        label: trans('np_transaction_description'),
        textAlign: 'left',
      },
    ];

    return <PageTableHeader columns={columns} />;
  }

  static renderEmpty() {
    return (
      <PageTableRow>
        <PageTableCell colSpan={20} noPadding>
          <TableEmpty txt="np_order_not_found" />
        </PageTableCell>
      </PageTableRow>
    );
  }

  constructor(props) {
    super(props);

    const { metadata } = props;
    this.transactionTypeMapping = metadata.payment_channel_ids.reduce(
      (result, item) => ({
        ...result,
        [item.value]: item.name,
      }),
      {},
    );
    this.transactionStatusMapping = metadata.summary_statuses.reduce(
      (result, item) => ({
        ...result,
        [item.value]: item.name,
      }),
      {},
    );
  }
  renderRow = (row, index) => {
    const { storeMapping } = this.props;
    return (
      <PageTableRow key={row.id}>
        <PageTableCell textAlign="center">{index}</PageTableCell>
        <PageTableCell>
          {this.transactionTypeMapping[row.payment_channel_id]}
        </PageTableCell>
        <PageTableCell>{formatCurrency(row.amount)}</PageTableCell>
        <PageTableCell>
          {this.transactionStatusMapping[row.summary_status]}
        </PageTableCell>
        <PageTableCell>
          {storeMapping[row.store_ref] && storeMapping[row.store_ref].name}
        </PageTableCell>
        <PageTableCell>{row.id}</PageTableCell>
        <PageTableCell>{row.ref}</PageTableCell>
        <PageTableCell>
          {formatDateTimeView(row.create_time * 1000)}
        </PageTableCell>
        <PageTableCell>
          {formatDateTimeView(row.valid_time * 1000)}
        </PageTableCell>
        <PageTableCell>{row.description}</PageTableCell>
      </PageTableRow>
    );
  };

  render() {
    const {
      table, changeActivePage, changePageSize, getList,
    } = this.props;

    return (
      <PageTable
        paginationMode={EnumPagingMode.PAGING_OFFSET_LIMIT.id}
        table={table}
        renderHeader={NowPortalOrderTable.renderHeader}
        renderRow={this.renderRow}
        renderEmpty={NowPortalOrderTable.renderEmpty}
        changeActivePage={changeActivePage}
        changePageSize={changePageSize}
        getList={getList}
      />
    );
  }
}

export default NowPortalOrderTable;



// WEBPACK FOOTER //
// ./foody/src/pages/NowPortal/NowPortalOrder/component/NowPortalOrderTable.jsx